// extracted by mini-css-extract-plugin
export default {"rank-inner":"UsersTable_rank-inner__c3wEM","rank-inner__avatar":"UsersTable_rank-inner__avatar__nOCMh"};